import "./OutOfStock.css";
import useWaitingListSignup from "../../hooks/useWaitingListSignup";
import MessageModal from "../../components/shared/MessageModal";
import MobileTopBar from "../../components/mobile/MobileTopBar";
import Footer from "../../components/shared/Footer";
import useResponsive from "../../hooks/useResponsive";
import { useLocation } from "react-router-dom";
import { outOfStock } from "../../Data/siteContent";

const OutOfStock = () => {
  const isMobile = useResponsive();
  const location = useLocation();
  const productName = location.state?.productName || "This product";
  const { email, handleEmailChange, handleSubscribe, feedback, closeFeedback } = useWaitingListSignup(productName);

  return (
    <div className="outofstock-container">
      <MessageModal
        isVisible={feedback.isVisible}
        title={feedback.title}
        message={feedback.message}
        type={feedback.type}
        onClose={closeFeedback}
      />
      {isMobile && <MobileTopBar />}
      <h1 className="outofstock-title">{outOfStock.title(productName)}</h1>
      <section className="outofstock-info">
        <p>{outOfStock.subtitle}</p>
        <div className="outofstock-form">
          <input
            type="email"
            placeholder={outOfStock.placeholder}
            value={email}
            onChange={handleEmailChange}
            autoComplete="off"
            autoCorrect="off"
            spellCheck="false"
            name="user_email"
            className="outofstock-input"
          />
          <button className="outofstock-button" onClick={handleSubscribe}>
            {outOfStock.button}
          </button>
        </div>
      </section>
      <section className="outofstock-instructions">
        <p className="outofstock-note">
          <strong>Note:</strong> {outOfStock.note}
        </p>
      </section>
      {isMobile && <Footer />}
    </div>
  );
};

export default OutOfStock;
